import ZkUserManager from './src/main'
ZkUserManager.install = function (Vue) {
  Vue.component(ZkUserManager.name, ZkUserManager)
}
export default ZkUserManager



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/userManage/index.js